import { useProjectContext } from "@hooks/context/useProjectContext";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { ProfileLineItem, createDefaultProfile } from "@interfaces/profile";
import { UserForm } from "@stories/molecules/UserForm/UserForm";
import { OrganisationLineItem } from "@interfaces/organisation";

interface UserModalProps {
  open: boolean;
  loading: boolean;
  organisation: OrganisationLineItem;
  existingUser?: ProfileLineItem;
  profiles: ProfileLineItem[];
  createUser: (profile: ProfileLineItem) => void;
  updateUser: (profile: ProfileLineItem) => void;
  handleClose: () => void;
}

export default function UserModal({
  loading,
  open,
  organisation,
  existingUser,
  profiles,
  createUser,
  updateUser,
  handleClose,
}: UserModalProps) {
  const { selectedProject } = useProjectContext();
  const onSubmit = async (profile: ProfileLineItem) => {
    if (profile) {
      if (existingUser) {
        await updateUser(profile);
      } else {
        await createUser(profile);
      }
      handleClose();
    }
  };

  if (!selectedProject) {
    return null;
  }

  const title = existingUser ? "Edit User" : "Create User";

  return (
    <div>
      <Dialog fullWidth={true} open={open} onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <UserForm
            user={existingUser || createDefaultProfile(organisation)}
            isEdit={!!existingUser}
            existingProfiles={profiles}
            handleSubmit={onSubmit}
            loading={loading}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
